<template>
  <el-container id="glSceneSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background: #FFFFFF;">
        <p style="font-size:25px;margin-left:25px;font-weight:bold;">{{ h_text }}</p>
        <div style="display:flex;justify-content:left;align-items:center;margin-left:40px">
          <span style="width:80px; margin-left:10px; color: #000000; font-size: 13px">
            场景名称：
          </span>
          <el-input
              placeholder="请输入场景名称"
              style="width:15vw;"
              clearable
              v-model="SceneName">
          </el-input>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
          <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
            场景描述：
          </span>
          <el-input
              placeholder="请输入场景描述"
              style="width:15vw;"
              clearable
              v-model="description">
          </el-input>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
            <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               所属区域：
            </span>
          <el-select v-model="edi_buildId" ref='select1' @change="getFloor('build')"
                     @visible-change='show_change1'
                     filterable placeholder="楼栋"
                     style="width:5vw;">
            <el-option
                v-for="item in li_build"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="edi_floorId" ref='select2' @change="getFloor('floor')"
                     @visible-change='show_change2' @click.native="checkLd()"
                     filterable placeholder="楼层"
                     style="width:5vw;margin-left:10px">
            <el-option
                v-for="item in li_floor"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="edi_roomId" ref='select3'
                     @visible-change='show_change3' @click.native="checkLd()"
                     clearable filterable placeholder="房间"
                     style="width:5vw;margin-left:10px">
            <el-option
                v-for="item in li_room"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
            <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               场景icon：
            </span>
          <el-image :src="scen_img" style="color:#FBFCFE;width:48px;height:48px"></el-image>
          <p style="margin-left:10px">选择icon</p>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
            <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               执行内容：
            </span>
          <el-button @click="add_dev" type="primary" plain>添加执行内容</el-button>
          <el-button @click="add_time" type="primary" plain>添加延时</el-button>
        </div>
        <div style="max-height:40vh;min-height:20vh; width:700px;overflow-y:auto">
          <div v-for="(t,item) in tab_start_dev" :key="t.id">
            <div v-if="t.type==='dev'"
                 style="display:flex;justify-content:left;align-items:center;height:35px;margin-top:10px;margin-left:130px">
              <div
                  style="width:15vw;height:25px;display:flex;justify-content:left;align-items:center;border: 1px solid #EFEFEF;padding: 5px;">
                <p style="margin-left:5px;color:#A0A0A0">{{ t.devName }}</p>
              </div>
              <el-image :src="dev_img" style="color:#FBFCFE;width:20px;height:20px"></el-image>
              <div @click="xz_act(item)"
                   style="width:15vw;height:25px;margin-left:15px;display:flex;justify-content:left;align-items:center;border: 1px solid #EFEFEF;padding: 5px;">
                <p style="margin-left:5px;color:#A0A0A0">{{ t.act }}</p>
                <p style="margin-left: auto;margin-right:5px;color: #1D66DD">设置</p>
              </div>
              <i @click="del_dev(t.id)" class="el-icon-circle-close"
                 style="font-size:20px;color:red;margin-left:15px"></i>
            </div>
            <div v-else
                 style="display:flex;justify-content:left;align-items:center;height:35px;margin-top:10px;margin-left:130px">
              <el-time-picker
                  v-model="t.time"
                  :picker-options="{
                   selectableRange: '00:00:00 - 23:59:59'
                }"
                  placeholder="选择时间"
                  style="width:417px;height:25px;display:flex;justify-content:left;align-items:center;border: 1px solid #EFEFEF;padding-top: 6px;">
              </el-time-picker>
              <i @click="del_dev(t.id)" class="el-icon-circle-close"
                 style="font-size:20px;color:red;margin-left:15px"></i>
            </div>
          </div>
        </div>
        <div>
          <div style="display:flex;justify-content:left;align-items:center;margin-top:30px;margin-left:130px">
            <el-button @click="onBack" size="medium">取消</el-button>
            <el-button v-if="this.h_text!=='场景详情'" @click="onKeep" size="medium" type="primary">保存</el-button>
          </div>
        </div>
      </el-main>
    </el-container>
    <el-dialog title='添加执行设备' center :close-on-click-modal="false"
               width="500px" height="600px" class="dialog_dev"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiAddDev'> <!--v-draggable 拖动-->
      <div style="display:flex;height:50px;width:100%;line-height:0.3;text-align:left;align-items: center;">
        <el-select v-model="con_area" ref='select4' @change="initDev"
                   @visible-change='show_change4'
                   clearable filterable placeholder="区域"
                   style="width:50%">
          <el-option
              v-for="item in li_xz_area"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="con_pid" ref='select5' @change="initDev"
                   @visible-change='show_change5'
                   clearable filterable placeholder="设备类型"
                   style="width:50%;margin-left:10px">
          <el-option
              v-for="item in li_pid"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="margin-top:1px;">
        <el-table :data=tabData class="myTable_db" :cell-style="tableYs" border
                  style="width:100%; font-size:11px; background:#ffffff;"
                  height="400px" show-overflow-tooltip :row-key="rowKey"
                  @selection-change="handleCurrentChange" ref="scenTable"
                  :header-cell-style="{'text-align':'left','background':'#F4F4F4','color':'#000000'}">
          <el-table-column
              type="selection"
              :reserve-selection="true"
              width="60">
          </el-table-column>
          <el-table-column v-for="(d,item) in this.liDevHead" :key=item
                           :prop=d.val :label=d.key>
          </el-table-column>
        </el-table>
        <el-pagination
            style="float:right; margin-right:0.5vw;margin-top:5px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange1"
            :current-page="page"
            :page-sizes="[10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total">
        </el-pagination>
      </div>
      <div style="margin-top:10px;display:flex;height:50px;width:100%;line-height:0.3;
                  text-align:left;align-items:center;">
        <el-button @click="dialog_Onclick('退出')" style="margin-left: auto">取消</el-button>
        <el-button @click="dialog_Onclick('保存')" type="primary">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title='添加执行动作' center :close-on-click-modal="false"
               width="400px" height="600px" class="dialog_dev"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiAddAct'> <!--v-draggable 拖动-->
      <div v-for="(d,index) in fil_li_ctl"
           style="display:flex;margin-bottom:10px;height:50px;width:100%;line-height:0.3;text-align:left;align-items:center;">
        <span style="margin-left:1vw; width:80px; color: #000000; font-size: 13px">
            {{ d.desc }}：
        </span>
        <el-select v-if="d.type==='enum'&&d.mode==='r'" v-model="d.value" ref='select3'
                   filterable placeholder="设备状态" disabled
                   style="width: 8vw;">
          <el-option
              v-for="item in d.li_d"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-select v-else-if="d.type==='enum'" v-model="d.value" ref='select4'
                   filterable placeholder="设备状态"
                   style="width: 8vw;">
          <el-option
              v-for="item in d.li_d"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input-number v-else-if="d.type==='int'&&d.mode==='r'" size="medium" v-model="d.value" style="width:8vw;"
                         :step=parseInt(d.step) :min=parseInt(d.min) :max=parseInt(d.max) :disabled="true">
        </el-input-number>
        <el-input-number v-else-if="d.type==='int'&&d.mode!=='r'" size="medium" v-model="d.value" style="width:8vw;"
                         :step=parseInt(d.step) :min=parseInt(d.min) :max=parseInt(d.max)>
        </el-input-number>
        <el-input-number v-else-if="d.type==='float'&&d.mode==='r'" size="medium" v-model="d.value" style="width:8vw;"
                         :precision="2" :step=parseFloat(d.step) :min=parseFloat(d.min) :max=parseFloat(d.max)
                         :disabled="true">
        </el-input-number>
        <el-input-number v-else-if="d.type==='float'&&d.mode!=='r'" size="medium" v-model="d.value" style="width:8vw;"
                         :precision="2" :step=parseFloat(d.step) :min=parseFloat(d.min) :max=parseFloat(d.max)>
        </el-input-number>
        <span v-else style="margin-left:1vw; width: 8vw;; color: #000000; font-size: 13px">
            {{ d.value }}
        </span>
        <el-checkbox v-model="checkboxes[index]" @change="handleChange(index)"
                     style="margin-left:10px"></el-checkbox>
      </div>
      <div style="margin-top:10px;display:flex;height:50px;width:100%;line-height:0.3;
                        text-align:left;align-items:center;">
        <el-button @click="dialog_act('退出')" style="margin-left: auto">取消</el-button>
        <el-button @click="dialog_act('保存')" type="primary">保存</el-button>
      </div>
      <!--      <div style="display:flex;justify-content:center;align-items:center;margin-top:15px">
              <span style="width:40px;margin-left:15px; color: #000000; font-size: 13px">
                     开关：
              </span>
              <el-select v-model="edi_act" ref='select6'
                         @visible-change='show_change6'
                         clearable filterable placeholder="请选择"
                         style="width:260px;">
                <el-option
                    v-for="item in li_act"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div style="margin-top:10px;display:flex;height:50px;width:100%;line-height:0.3;
                        text-align:left;align-items:center;">
              <el-button @click="dialog_act('退出')" style="margin-left: auto">取消</el-button>
              <el-button @click="dialog_act('保存')" type="primary">保存</el-button>
            </div>-->
    </el-dialog>
  </el-container>
</template>

<script>
import CryptoJS from 'crypto-js';

export default {
  name:"glSceneSon",
  data() {
    return {
      isDev:false,
      isPid:false,
      isCtr:true,
      page:1,
      pageSize:10,
      total:10,
      pageAll:1,
      totalAll:10,
      checkIndex:0,
      checkboxes:[
        false,
        false
      ],
      li_dev:[],
      h_text:"新增场景",
      li_h_text:[
        {"text":"节能策略","colour":"#B7B7B7","pages":""},
        {"text":"场景策略","colour":"#B7B7B7","pages":""}
      ],
      rqS:[
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "日"
      ],
      check_rqS:[
        "一",
        "二",
        "三",
        "四",
        "五"
      ],
      checkAll:false,
      isIndeterminate:false,
      scen_img:require('@/assets/device1.png'),
      dev_img:require('@/assets/device.png'),
      tab_xz:'手动触发',
      tab_start_dev:[],
      tab_end_dev:[
        {id:0,dev:"触发设备",act:"触发属性"}
      ],
      value1:[
        new Date(2016,9,10,8,40),
        new Date(2016,9,10,9,40)
      ],
      daiAddDev:false,
      daiAddAct:false,
      li_ctl:[],
      id:"",
      edi_auth:"",
      li_auth:[],
      SceneName:"",
      description:"",
      passWd:"",
      nickName:"", /*账号*/
      liDevHead:[
        {'key':"设备名称",'val':"devName","w":"auto"}
      ],
      tabData:[],
      currentRow:[],
      item:0,
      con_area:"",
      li_xz_area:[],
      li_pid:[],
      con_pid:"",
      li_build:[],
      edi_buildId:"",
      li_floor:[],
      edi_floorId:"",
      li_room:[],
      edi_roomId:"",
      roomId:"",
      li_area:[],
      li_buildInfo:[],
      edi_act:[],
      li_act:[
        {"value":1,"label":"开启"},
        {"value":0,"label":"关闭"}
      ]
    };
  },
  methods:{ /*方法存放*/
    handleChange(i) {
      this.checkIndex = i;
      this.checkboxes = this.checkboxes.map((val,index) => index === i);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.initDev();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.initDev();
    },
    add_dev() {
      this.page = 1;
      if (!this.isDev) {
        this.getDev();
      }
      if (!this.isPid) {
        this.getPid();
      }
      this.daiAddDev = true;
      setTimeout(() => {
        this.$refs.scenTable.clearSelection(); /*清空选中*/
      },100);
    },
    xz_act(item) { /*选择执行动作*/
      this.item = item;
      console.log(this.tab_start_dev[this.item]);
      this.getPidArg(this.tab_start_dev[this.item]["pid"],this.tab_start_dev[this.item]["cmd"]);
      this.daiAddAct = true;
    },
    del_dev(id) {
      const index = this.tab_start_dev.findIndex(item => item.id === id);
      this.tab_start_dev.splice(index,1);
    },
    add_time() {
      if (this.tab_start_dev.length > 0) {
        this.tab_start_dev.push({
          id:this.tab_start_dev[this.tab_start_dev.length - 1]["id"] + 1,
          type:"time",time:new Date(2016,9,0,0,0,1),dev:"触发设备",act:"触发属性"
        });
      } else {
        this.tab_start_dev.push({
          id:0,
          type:"time",time:new Date(2016,9,0,0,0,1),dev:"触发设备",act:"触发属性"
        });
      }
    },
    onXz() {
      console.log(this.tab_xz);
    },
    rowKey(row) { /*返回对应唯一值防止选中乱跳*/
      return row.did;
    },
    handleCurrentChange(val) { /*获取所有选中行*/
      this.currentRow = val;
      console.log(this.currentRow);
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:left;background:#FFFFFF;color:#000000';
    },
    dialog_Onclick(v) {
      switch (v) {
        case "保存":
          let id1 = 0;
          if (this.tab_start_dev.length > 0) {
            id1 = this.tab_start_dev[this.tab_start_dev.length - 1]["id"] + 1;
          }
          for (let i = 0; i < this.currentRow.length; i++) {
            console.log(this.currentRow[i]);
            this.tab_start_dev.push({
              id:id1 + i,
              type:"dev",
              did:this.currentRow[i]["did"],
              pid:this.currentRow[i]["pid"],
              devName:this.currentRow[i]["devName"],
              act:"执行动作",
              cmd:""
            });
          }
          this.daiAddDev = false;
          break;
        case "退出":
          clearTimeout(this.timer_wd);  //按钮高亮3毫秒变回
          this.timer_wd = setTimeout(() => {
            this.dailog_qxbg = '#283A4D';
          },300);
          this.daiAddDev = false; /*将dialog关闭*/
          break;
      }
    },
    dialog_act(v) {
      switch (v) {
        case "保存":
          // if (!this.fil_li_ctl[this.checkIndex]["value"]) {
          //   this.$message.error("请先选择参数值")
          //   return
          // }
          let cat_name = this.fil_li_ctl[this.checkIndex]["name"];
          let cat_val = this.fil_li_ctl[this.checkIndex]["value"];
          let txt_val = this.fil_li_ctl[this.checkIndex]["value"];
          this.tab_start_dev[this.item]["cmd"] = JSON.stringify({[cat_name]:cat_val});
          console.log("----",this.fil_li_ctl[this.checkIndex]);
          if (this.fil_li_ctl[this.checkIndex]["type"] === "enum") {
            const d = this.fil_li_ctl[this.checkIndex]["li_d"].find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
              return fruit['value'] === cat_val;
            });
            if (d !== undefined) {
              txt_val = d["label"];
            }
          }
          this.tab_start_dev[this.item]["act"] = `${this.fil_li_ctl[this.checkIndex]["desc"]}：${txt_val}`;
          this.daiAddAct = false;
          console.log(this.tab_start_dev);
          break;
        case "退出":
          clearTimeout(this.timer_wd);  //按钮高亮3毫秒变回
          this.timer_wd = setTimeout(() => {
            this.dailog_qxbg = '#283A4D';
          },300);
          this.daiAddAct = false; /*将dialog关闭*/
          break;
      }
    },
    checksChange(val) {
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.rqS.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.rqS.length;
    },
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    show_change(item) {
      if (item) {
        this.$refs.select.focus();
      } else {
        this.$refs.select.blur();
      }
    },
    show_change1(item) {
      if (item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item) {
      if (item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item) {
      if (item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    show_change4(item) {
      if (item) {
        this.$refs.select4.focus();
      } else {
        this.$refs.select4.blur();
      }
    },
    show_change5(item) {
      if (item) {
        this.$refs.select5.focus();
      } else {
        this.$refs.select5.blur();
      }
    },
    show_change6(item) {
      if (item) {
        this.$refs.select6.focus();
      } else {
        this.$refs.select6.blur();
      }
    },
    onKeep() {
      if (!this.edi_roomId) {
        this.$message.error("请先选择区域");
        return;
      }
      if (this.isCtr) {
        this.isCtr = false;
        if (this.h_text === '新增场景') {
          this.addScene();
        } else {
          this.changeScene();
        }
        setTimeout(() => {
          this.isCtr = true;
        },600);
      }
    },
    addScene() {
      let params = {
        'name':this.SceneName,
        'description':this.description,
        'roomId':this.edi_roomId,
        'projectId':localStorage.getItem("projectId"),
        'isBleScene':false,
        'sceneItem':[]
      };
      let t = 0;
      for (let i = 0; i < this.tab_start_dev.length; i++) {
        /* if (this.tab_start_dev[i]["cmd"]) {
         this.$message.error("有设备未选择执行动作")
         return
         }*/
        if (this.tab_start_dev[i]["type"] === "dev") {
          params.sceneItem.push({
            "sort":i,
            "did":this.tab_start_dev[i]["did"],
            "pid":this.tab_start_dev[i]["pid"],
            "cmd":this.tab_start_dev[i]["cmd"],
            "name":this.tab_start_dev[i]["act"],
            "devName":this.tab_start_dev[i]["devName"],
            'roomId':this.edi_roomId,
            'projectId':localStorage.getItem("projectId")
          });
        } else { /*延时执行*/
          const hours = this.tab_start_dev[i]["time"].getHours();
          const minutes = this.tab_start_dev[i]["time"].getMinutes();
          const seconds = this.tab_start_dev[i]["time"].getSeconds();
          this.seconds = hours * 3600 + minutes * 60 + seconds;
          params.sceneItem[params.sceneItem.length - 1]["delay"] = this.seconds;
          /*  params.sceneItem.push({
           "delay": this.tab_start_dev[i]["time"],
           'roomId': this.edi_roomId,
           'projectId': localStorage.getItem("projectId"),
           })*/
        }
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.newScene,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加场景成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("添加场景失败");
        }
      });
    },
    changeScene() {
      let params = {
        'id':this.id,
        'name':this.SceneName,
        'description':this.description,
        'roomId':this.edi_roomId,
        'projectId':localStorage.getItem("projectId"),
        'isBleScene':false,
        'sceneItem':[]
      };
      for (let i = 0; i < this.tab_start_dev.length; i++) {
        if (this.tab_start_dev[i]["type"] === "dev") {
          params["sceneItem"].push({
            "sort":i,
            "did":this.tab_start_dev[i]["did"],
            "pid":this.tab_start_dev[i]["pid"],
            "cmd":this.tab_start_dev[i]["cmd"],
            "name":this.tab_start_dev[i]["act"],
            "devName":this.tab_start_dev[i]["devName"],
            'roomId':this.edi_roomId,
            'projectId':localStorage.getItem("projectId")
          });
        } else { /*延时执行*/
          const hours = this.tab_start_dev[i]["time"].getHours();
          const minutes = this.tab_start_dev[i]["time"].getMinutes();
          const seconds = this.tab_start_dev[i]["time"].getSeconds();
          this.seconds = hours * 3600 + minutes * 60 + seconds;
          params.sceneItem[params.sceneItem.length - 1]["delay"] = this.seconds;
        }
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.replaceSceneItem,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack() {
      this.$router.go(-1);
    },
    initView(area_type = "") {
      let l = [];
      let isCleanF = true;
      let isCleanR = true;
      let l_d = this.li_buildInfo;
      for (let i = 0; i < l_d.length; i++) {
        let d = {
          value:l_d[i]['id'],
          label:l_d[i]['name']
        };
        if (this.edi_floorId === l_d[i]['id']) {
          isCleanF = false;
        }
        l.push(d);
      }
      this.li_floor = l;
      l = [];
      for (let j = 0; j < l_d.length; j++) {
        if (this.edi_floorId && l_d[j]['id'] !== this.edi_floorId) {
          continue;
        }
        for (let k = 0; k < l_d[j]['rooms'].length; k++) {
          let d = {
            value:l_d[j]['rooms'][k]['id'],
            label:l_d[j]['rooms'][k]['name']
          };
          if (this.edi_roomId === l_d[j]['rooms'][k]['id']) {
            isCleanR = false;
          }
          l.push(d);
        }
      }
      this.li_room = l;
      if (isCleanF) {
        this.edi_floorId = "";
      }
      if (isCleanR) {
        this.edi_roomId = "";
      }
    },
    initDev() {
      let data = this.li_dev;
      let li_d = [];
      let li_a = []; /*区域*/
      let j = 1;
      for (let i = 0; i < data.length; i++) {
        let d = {
          item:j,
          did:data[i]['did'],
          pid:data[i]['pid'],
          devName:data[i]['name'],
          devMac:data[i]['did'],
          stateId:data[i]['stateId'],
          roomId:data[i]['roomId']
        };
        console.log(data[i]);
        if (data[i]['roomId']) {
          d['floorId'] = data[i]['room']['floorId'];
          if (data[i]['room']['floor']) {
            d['buildId'] = data[i]['room']['floor']['buildingId'];
            d['devArea'] = data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            if (data[i]['room']['floor']['building']) {
              d['devArea'] = data[i]['room']['floor']['building']['name'] + "-" + data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            }
          }
        } else if (data[i]['floorId']) {
          d['floorId'] = data[i]['floorId'];
          if (data[i]['floor']) {
            d['buildId'] = data[i]['floor']['buildingId'];
            d['devArea'] = data[i]['floor']['name'];
            if (data[i]['floor']['building']) {
              d['devArea'] = data[i]['floor']['building']['name'] + "-" + data[i]['floor']['name'];
            }
          }
        }
        let exists = li_a.some(dict => dict.value === d['devArea']); /*筛选字典数组*/
        if (!exists) {
          li_a.push({value:d['devArea'],label:d['devArea']});
        }
        const aliceItems = this.li_pid.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
          return fruit['value'] === d.pid;
        });
        if (aliceItems !== undefined) {
          d["devType"] = aliceItems["label"];
        }
        // if (!d["stateId"]) {
        //   d["stateId"] = 2
        //   d["devState"] = "离线"
        // } else {
        //   const state = this.li_state.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        //     return fruit['value'] === d.stateId;
        //   })
        //   if (state !== undefined) {
        //     d["devState"] = state["label"];
        //   }
        // }
        if (this.con_pid && !d.pid.includes(this.con_pid)) {
          continue;
        }
        if (this.con_area && !d.devArea.includes(this.con_area)) {
          continue;
        }
        li_d.push(d);
        j += 1;
      }
      this.li_xz_area = li_a;
      this.total = li_d.length;
      this.tabData = li_d.slice((this.page - 1) * this.pageSize,this.page * this.pageSize);
    },
    getDev() {
      this.getDevdata();
    },
    getDevdata() {
      if (this.pageAll <= this.totalAll / 30 + 1) {
        const params = {
          'page':this.pageAll,
          'pageSize':30,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log("getDeviceList",params);
        this.$api.post(this.$urls.ip + this.$urls.getDeviceList,params,headers).then(res => {
          console.log(res.data.data);
          this.totalAll = res.data.data["total"];
          let l_d = this.li_dev;
          for (let i = 0; i < res.data.data["list"].length; i++) {
            l_d.push(res.data.data["list"][i]);
          }
          this.li_dev = l_d;
          this.isDev = true;
          this.pageAll += 1;
          this.getDevdata();
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("获取设备信息失败");
          }
        });
      } else {
        this.initDev();
      }
    },
    getPid() {
      const params = {
        'page':1,
        'pageSize':10000
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getPidList,params,headers).then(res => {
        console.log(res.data.data);
        let data = res.data.data.list;
        let l = [];
        for (let i = 0; i < data.length; i++) {
          let d = {
            value:data[i]['pid'],
            label:data[i]['name']
          };
          l.push(d);
        }
        this.li_pid = l;
        this.isPid = true;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备类型失败");
        }
      });
    },
    getBuilding() {
      const params = {
        "page":1,
        "pageSize":1000,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getBuildingList,params,headers).then(res => {
        console.log("楼栋列表：",res.data.data);
        this.li_area = res.data.data.list;
        let l_d = this.li_area;
        let l = [];
        for (let i = 0; i < l_d.length; i++) {
          let d = {
            value:l_d[i]['id'],
            label:l_d[i]['name']
          };
          l.push(d);
        }
        this.li_build = l;
        this.getFloor("build");
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取区域失败");
        }
      });
    },
    checkLd() {
      if (!this.edi_buildId) {
        this.$message.info("请先选择楼栋");
      }
    },
    getFloor(area_type = "") {
      console.log(this.edi_buildId);
      const params = {
        "page":1,
        "pageSize":1000,
        "id":this.edi_buildId,
        "projectId":localStorage.getItem("projectId")
      };
      if (area_type === "build") {
        if (this.edi_buildId) {
          params["id"] = this.edi_buildId;
          const headers = {
            'token':localStorage.getItem("token")
          };
          this.$api.post(this.$urls.ip + this.$urls.getBuildingInfo,params,headers).then(res => {
            console.log("楼栋信息：",res.data.data);
            this.li_buildInfo = res.data.data["floors"];
            this.initView(area_type);
          }).catch(error => {
            console.log(error);
            if (error) {
              this.$message.error("获取楼层数据失败");
            }
          });
        }
      } else if (area_type === "floor") {
        this.initView(area_type);
      }
    },
    getPidArg(pid,cmd) {
      let key1 = "";
      let val1 = "";
      let item = 0;
      if (cmd) { /*当命令为真时再解析*/
        cmd = JSON.parse(cmd);
        for (const key in cmd) {
          if (cmd.hasOwnProperty(key)) {
            key1 = key;
            val1 = cmd[key];
          }
        }
      }
      const params = {
        'pid':pid
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getPidArg,params,headers).then(res => {
        console.log("pid参数",res.data.data);
        let data = res.data.data["iotPidProfile"]["properities"];
        console.log("data",data);
        let l = [];
        for (let i = 0; i < data.length; i++) {
          let d = {
            "pid":pid,
            "name":data[i]['name'],
            "desc":data[i]['desc'],
            "type":data[i]["define"]['type'],
            "mode":data[i]['mode'],
            "value":""
          };
          if (d["mode"] === "r") {
            continue;
          }
          if (d['type'] === 'int' || d['type'] === 'float') {
            d["step"] = parseInt(data[i]["define"]["step"]);
            d["min"] = parseInt(data[i]["define"]["min"]);
            d["max"] = parseInt(data[i]["define"]["max"]);
          } else if (d['type'] === 'enum') {
            let l1 = [];
            for (let j = 0; j < data[i]["define"]["mapping"].length; j++) {
              l1.push({
                "label":data[i]["define"]["mapping"][j]["desc"],
                "value":parseInt(data[i]["define"]["mapping"][j]["value"])
              });
            }
            d["li_d"] = l1;
            d["value"] = parseInt(l1[0]["value"]);
          } else { /*字符串*/
            d["value"] = data[i]['name'];
          }
          if (d.name === key1) { /*初始化选中值*/
            d.value = val1;
            item = i;
          }
          l.push(d);
        }
        this.li_ctl = l;
        this.handleChange(item);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    initScene(sceneItem) {
      console.log(sceneItem);
      let l_d = [];
      for (let i = 0; i < sceneItem.length; i++) {
        const d = {
          "type":"dev",
          "id":sceneItem[i]["id"],
          "did":sceneItem[i]["did"],
          "pid":sceneItem[i]["pid"],
          "cmd":sceneItem[i]["cmd"],
          "act":sceneItem[i]["name"],
          "devName":sceneItem[i]["devName"]
        };
        // if (d["cmd"].includes("1")) {
        //   d["act"] = "开启"
        // } else {
        //   d["act"] = "关闭"
        // }
        l_d.push(d);
        if (sceneItem[i]["delay"]) {
          // const h = parseInt(sceneItem[i]["delay"] / 3600)
          // const m = parseInt(sceneItem[i]["delay"] % 60)
          // const s = parseInt(sceneItem[i]["delay"] % 60)
          l_d.push({"type":"time","time":new Date(2016,9,0,0,0,sceneItem[i]["delay"])});
        }
      }
      this.tab_start_dev = l_d;
    }
  },
  mounted() { /*页面加载时调用*/
    const value = this.$route.query.key;
    console.log(value);
    if (value === "addScene") {
      this.h_text = "新增场景";
    } else if (value === "changeScene") {
      this.h_text = "修改场景信息";
      if (this.$route.query.id) {
        this.id = parseInt(this.$route.query.id);
      }
      this.SceneName = this.$route.query.name;
      this.description = this.$route.query.description;
      this.li_room.push({
        value:parseInt(this.$route.query.roomId),
        label:this.$route.query.roomName
      });
      this.li_floor.push({
        value:parseInt(this.$route.query.floorId),
        label:this.$route.query.floorName
      });
      this.li_build.push({
        value:parseInt(this.$route.query.buildId),
        label:this.$route.query.buildName
      });
      if (this.$route.query.roomId) {
        this.edi_roomId = parseInt(this.$route.query.roomId);
      }
      if (this.$route.query.floorId) {
        this.edi_floorId = parseInt(this.$route.query.floorId);
      }
      if (this.$route.query.buildId) {
        this.edi_buildId = parseInt(this.$route.query.buildId);
      }
      this.initScene(this.$route.query.sceneItem);
    } else {
      this.h_text = "场景详情";
      if (this.$route.query.id) {
        this.id = parseInt(this.$route.query.id);
      }
      this.SceneName = this.$route.query.name;
      this.description = this.$route.query.description;
      this.edi_roomId = parseInt(this.$route.query.roomId);
      this.edi_floorId = parseInt(this.$route.query.floorId);
      this.edi_buildId = parseInt(this.$route.query.buildId);
      this.li_room.push({
        value:this.edi_roomId,
        label:this.$route.query.roomName
      });
      this.li_floor.push({
        value:this.edi_floorId,
        label:this.$route.query.floorName
      });
      this.li_build.push({
        value:this.edi_buildId,
        label:this.$route.query.buildName
      });
      this.initScene(this.$route.query.sceneItem);
    }
    this.getBuilding();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    // fil_tabData() {
    //   return this.tabData.filter(item => {
    //     this.state = true
    //     if (this.con_pid && !item.pid.includes(this.con_pid)) {
    //       this.state = false
    //     }
    //     if (this.con_area && !item.devArea.includes(this.con_area)) {
    //       this.state = false
    //     }
    //     return this.state
    //   });
    // },
    fil_li_ctl() {
      return this.li_ctl;
    }
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#glSceneSon {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.dialog_dev {
  .el-dialog__title {
    color: #000000;
    font-weight: 900;
  }

  .el-dialog__header {
    color: #000000;
    background: #FFFFFF;
  }

  .el-dialog__body {
    color: #000000;
    background: #FFFFFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/scene/sceneSon.vue